import Button from '@mui/material/Button';
import React from 'react';

import { Link } from 'react-router-dom';

export const PrefilledAccessPointButtons = () => {
    const accessPointCodes = [
        'YSALC-00740',
        'YSALC-01264',
        'YSASE-00348',
        'YSALC-00650',
        'YSALC-01368',
        'YSALC-01029',
        'YSALC-00762',
        'YSALC-00753',
        'YSALC-00755',
        'YSALC-00525',
        'YCA01=PM54',
        'YDA01=ECA5',
        'YCA01=PM15',
        'YSALC-00754',
        'YSALC-00605',
        'YSALC-00717',
        'YSALC-00714',
        'YCA02=PM54',
        'YSALC-00752',
        'YSASE-00042',
        'YSALC-01393',
        'YEAP-ADPPE9',
        'YSALC-00247',
        'YSALC-00658',
        'YSALC-00279',
        'YSALC-00471',
        'YDALC01-PPE192',
        'YSALC-00920',
        'YDA01=TAG41',
        'YSALC-00860',
        'YSALC-01024',
        'YEAP-ADPPE3',
        'YSALC-00861',
        'YSALC-00914',
        'YEAP-ADPPE10',
        'YEAP-ADPPE8',
        'YEAP-ADPPE4',
        'YEA01.PSR=152',
        'YEA01.SWY=151',
        'YEAP-ADPPE2',
        'YEA01.MED=179',
        'YSASE-00120',
        'YSALC-01977',
        'NOT-Valid-will-cause-error',
    ];

    return (
        <>
            {accessPointCodes.map((accessPointCode) => (
                <Button
                    key={accessPointCode}
                    variant="contained"
                    size="small"
                    component={Link}
                    to={`/accesspoint/${accessPointCode}`}
                >
                    {accessPointCode}
                </Button>
            ))}
        </>
    );
};
